import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PRODUCTS_STATIC_DATA } from 'mocks/queries';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import removeTypename from 'commons/removeTypename';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import useProductVariantsToShow from 'hooks/useProductListingData/useProductVariantsToShow';
import useProductListingWithFavorites from 'hooks/useProductListingData/useProductListingWithFavorites';
import addDerivedProductData from 'hooks/useProductListingData/helpers/addDerivedProductData';

const useProductCardDataNext = ({ productIds = [] }) => {
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? '';

  const { data, loading } = useQuery(GET_PRODUCTS_STATIC_DATA, {
    fetchPolicy: 'cache-and-network',
    variables: {
      productIds,
      zipCode,
      ...getVisitorLocationQueryVariables(userLocation?.stateShortName),
      limit: -1,
    },
    skip: productIds.length === 0,
  });

  const queryData = data?.getProductsStaticData;
  const pageData = useMemo(() => (queryData ? removeTypename(queryData) : {}), [
    queryData,
  ]);
  const { products: productsWithoutDerivedData, upholsteryOptions } = pageData;

  const products = useMemo(
    () =>
      productsWithoutDerivedData?.map(product =>
        addDerivedProductData({ product, upholsteryOptions })
      ) || [],
    [productsWithoutDerivedData, upholsteryOptions]
  );

  const productsWithVariantsToShow = useProductVariantsToShow({
    colorFilters: null,
    products,
    upholsteryLabelFilters: null,
  });

  const productsToShowWithFavorites = useProductListingWithFavorites({
    products: productsWithVariantsToShow,
  });

  return {
    loading,
    products: productsToShowWithFavorites,
  };
};

export default useProductCardDataNext;
